import React from 'react';
import Vod from './Player/Vod';
import Live from './Player/Live';
import Tabs from './Player/Tabs.js';
import Speaker from './Player/Speaker.js';
import FixedSpeaker from './Player/FixedSpeaker';


export default class Player extends React.Component {
  
  state = {
    loading: true
  }

  async componentDidMount() {
    if (window.live) {
      await window.sdk.live.loadPublicInfo();
      this.setState({
        loading: false
      })
    }
    else {
      this.setState({
        loading: false
      })
    }

    if ( window.sdk.isExtended() ) {
      this.resizeVideo();
      window.addEventListener('resize', this.resizeVideo);
      window.addEventListener('load', this.resizeVideo);
    }
  }

  componentWillUnmount() {
    if ( window.sdk.isExtended() ) {
      window.removeEventListener('resize', this.resizeVideo);
      window.removeEventListener('load', this.resizeVideo);
    }
  }

  resizeVideo() {
    // Get the window width and height
    const breakpoint = 768;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const left = document.querySelector('.left');
    const right = document.querySelector('.right');
    const fixedSpeaker = document.querySelector('.fixed-speaker');
    
    if ( !left || !right || !fixedSpeaker ) {
      return;
    }

	window.portraitMode = false;
    if ( windowWidth < breakpoint ) {
      left.style.height = '';
      right.style.height = '';
      fixedSpeaker.style.height = '';
	  window.portraitMode = true;
	  document.body.classList.add('portraitMode');
      return;
    }
	else {
		document.body.classList.remove('portraitMode');
	}

    let height = (windowWidth - (0.34 * windowWidth)) * (9 / 16);
    height = height / windowHeight * 100;
    const rightHeight = 100 - height;
    

    right.style.height = rightHeight + '%';
    left.style.height = height + '%';
    fixedSpeaker.style.height = height + '%';
  }
  
  render() {
	  
    if(this.state.loading)
      return null;
    if (window.live)
      return (
        <div className={ 'live ' + (window.sdk.isOverlay() ? 'tabs-overlay ' : (window.sdk.isExtended() ? 'tabs--fixed' : 'tabs--normal' )) + (((window.custom.synople && window.custom.synople.extraits !== false && !window.local) || window.query.showextract) ? '' : ' tabs--noextract') + (window.query.hideextract ? ' tabs--noextract':'')}>
          <Speaker />
          <div style={{ position: 'absolute' }} id="logger"></div>
          <div className={ (!window.sdk.showTab() || window.sdk.isOverlay()) ? 'full' : 'left'}>
            <Live />
          </div>
          {(window.sdk.showTab() && window.sdk.isExtended()) && <FixedSpeaker />}
          { window.sdk.showTab() && !window.sdk.isOverlay() &&
            <div className="right">
              <Tabs />
            </div>
          }
        </div>
      );
    else
      return (
        <div className={ 'vod ' + (window.sdk.isOverlay() ? 'tabs-overlay ' : (window.sdk.isExtended() ? 'tabs--fixed' : 'tabs--normal' )) + (((window.custom.synople && window.custom.synople.extraits !== false && !window.local) || window.query.showextract) ? '' : ' tabs--noextract') + (window.query.hideextract ? ' tabs--noextract':'')}>
          <Speaker />
          <div className={ (!window.sdk.showTab() || window.sdk.isOverlay()) ? 'full' : 'left'}>
            <Vod />
          </div>
          {(window.sdk.showTab() && window.sdk.isExtended()) && <FixedSpeaker />}
          { window.sdk.showTab() && !window.sdk.isOverlay() &&
            <div className="right">
              <Tabs />
            </div>
          }
          <div id="customstyle"></div>
        </div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/Player.js